import { collection, orderBy, query } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import { useEffect, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";

export const useNationalities = () => {
  const [nationalities, setNationalities] = useState([]);
  const [value, loading, error] = useCollection(
    query(collection(db, "nationalities"), orderBy("nationality", "asc"))
  );
  useEffect(() => {
    const run = () => {
      if (value) {
        const docs = value.docs.map((snap) => snap.data().nationality);
        setNationalities(docs);
      }
    };
    run();
  }, [value]);

  return { nationalities, loading, error };
};
